import { ControlLabel, FormGroup } from 'react-bootstrap';
import React from 'react';
import { Form } from 'react-final-form';
import EmployeesAutocomplete from '../employees-autocomplete/EmployeesAutocomplete.jsx';
import IncludeEmployeesCheckbox from '../employees-form-field/IncludeEmployeesCheckbox.jsx';
import EmployeeRow from './EmployeeRow.jsx';
import EmployeeForm from '../employees/EmployeeFormModal/EmployeeForm.jsx';
import AuthorizedAction from '../AuthorizedAction.js';

const ManageGroupForm = ({
  onParentSelect,
  onAddEmployeeSubmit,
  newEmployeeEntities,
  handleSelect,
  group,
  groupEntity,
  groupEmployees,
  handleSelectAll,
  pending,
  disabledSelectAll,
  hideSelectAll,
  additionalSearchParams,
  showEmployeeForm,
  setShowEmployeeForm,
  errors,
}) => {
  return showEmployeeForm && !groupEntity.archived ? (
    <div
      className="
      component
      component-border-bottom
      component-border-top
      component-border-left
      component-border-right m-b-24"
    >
      <Form
        onSubmit={onAddEmployeeSubmit}
        onManualSubmit={onAddEmployeeSubmit}
        onManualCancel={setShowEmployeeForm}
        onParentSelect={onParentSelect}
        manuallyGeneratedError={errors}
        selectedEntities={newEmployeeEntities}
        isInitiative={false}
        isGroupSelectDisabled
        component={EmployeeForm}
      />
    </div>
  ) : (
    <React.Fragment>
      <FormGroup className="m-b-16">
        <ControlLabel>Select or Add Impacted People</ControlLabel>
        <EmployeesAutocomplete
          handleSelect={handleSelect}
          additionalSearchParams={{
            groupIds: [group.id],
            ...additionalSearchParams,
          }}
          isItemActive={(id) => group.employee_ids.includes(id)}
        />
      </FormGroup>
      {!hideSelectAll ? (
        <div className="m-b-16">
          <IncludeEmployeesCheckbox
            disabledSelectAll={disabledSelectAll}
            group={groupEntity}
            isChecked={
              groupEntity.employeeIds.length &&
              groupEntity.employeeIds.length === group.employee_ids.length
            }
            handleSelect={handleSelectAll}
          />
        </div>
      ) : null}

      <div className="flex flex-justify">
        <ControlLabel>
          Selected Employee(s)
          <strong className="bordered bordered-xs text-muted m-l-8">
            Total:&nbsp;
            <span className="text-info-brand count">
              {group.employee_ids.length}
            </span>
          </strong>
        </ControlLabel>

        {!showEmployeeForm && !groupEntity.archived ? (
          <AuthorizedAction action="create" subject="employee">
            <button
              type="button"
              className="btn-link"
              onClick={() => setShowEmployeeForm(!showEmployeeForm)}
            >
              {' '}
              + Add People
            </button>
          </AuthorizedAction>
        ) : null}
      </div>

      {pending ? <h5 className="m-b-8">Loading...</h5> : null}

      {Object.values(groupEmployees).map((e) => {
        if (!group.employee_ids.includes(e.id)) return null;

        return (
          <EmployeeRow key={e.id} employee={e} handleRemove={handleSelect} />
        );
      })}
    </React.Fragment>
  );
};

export default ManageGroupForm;
